import { useCallback, useEffect, useMemo } from "react"
import { useApolloClient } from "@apollo/client"

import { useAppSelector, useAppDispatch } from '../../../Store'
import { gqlActions } from "../gqlData_Reducer"

/* eslint-disable */
import { USER_LOGIN, LoginResponse, LoginArgs, Farms_Data, User_Data, USER_INFO, UserInfoResponse, UPDATE_USER_INFO, UpdateUserInfoArgs, UpdateUserInfoResponse, Farm_Data, FarmInfoResponse, FARM_INFO, UpdateFarmInfoArgs, UPDATE_FARM_INFO, FarmInfoArgs, UpdateFarmInfoResponse, Def_MutationResponse, CreateUserResponse, CREATE_USER, CreateArgs, GET_SERVER_IP } from "./GQLCalls/getCalls"
import { USER_FARMS, FarmsResponse, UserFarmsArgs, UserInfoArgs } from "./GQLCalls/getCalls"

import { UserStates, UserActions } from "./UserSlices/userSlice"
import { PersistPartial } from "redux-persist/lib/persistReducer";
import { CREATE_RESET_PASSWORD_ENTRY, CreateResetResponse, TOKEN_RESET_PASSWORD, TokenResetPassword, TokenResetResponse } from "./GQLCalls/createCalls"
import { CompanySettings, CompanySettingsResponse, GET_COMPANY_SETTINGS, UPDATE_COMPANY_SETTINGS, UpdateCompanySettingsResponse } from "./GQLCalls/farmSettingsCalls"
/* eslint-enable */

export type UseUser = {
  doLogin:(username:string, password:string) => Promise<boolean>,
  doLogOut:() => void,
  createNewUser:(username: string, password: string, firstname:string, lastname:string, email:string, phone:string)=>void,
  createUserResetToken: (username: string) => Promise<boolean>;
  tokenResetPassword: (token: string, password:string) => Promise<boolean>;
  getUserFarms:()=>void
  getUserData:(jwt?:string)=>void,
  updateUserData:(firstname:string,lastname:string,phone:string,email:string,address:string,country:string, jwt?:string)=>void,
  getFarmData:(domain:string)=>void,
  updateFarmData:(name:string, city:string,street:string,phone:string,vat:string,email:string,domain?:string)=>void,
  getFarmSettings: (domain:string) => void,
  updateFarmSettings: (domain?:string, timeZone?: number, feedDayStart?: string) => void,
  getServerIp: () => void;
  data: UserStates & PersistPartial,
  userToken?: string,
  userFarms?: Farms_Data[],
  userData?: User_Data
  farmData?: Farm_Data[]
  farmSettings?: CompanySettings,
  serverIp: string
} 

export const useUser = (userToken?:string):UseUser => {
  const dispatch = useAppDispatch()
  const client = useApolloClient()

  const UserStates = useAppSelector(({graphQlData:{user}}) => user)
  const {fullState, UserToken, UserFarms, UserData, FarmData, farmSettings, serverIp} = useMemo(() => {
    //TODO: UserStates.UserInfo is not array....
    var info = (UserStates.UserInfo as unknown) as any
    return {
      fullState: UserStates, 
      UserToken: UserStates.UserToken, 
      UserFarms: UserStates.UserFarms,
      UserData: info&&info[0]?info[0]:undefined,
      FarmData: UserStates.FarmInfo,
      farmSettings: UserStates.FarmSettings,
      serverIp: UserStates.serverIp
    }
  }, [UserStates])
  
  useEffect(() => {
    if (userToken) {
      getUserFarms()
    }
  }, []) // ??? UserToken

  const getUserFarms = useCallback(async (farm_id?:number) => {
    if (UserToken) {
      await client.query<FarmsResponse>({query:USER_FARMS, variables:{farm_id} as UserFarmsArgs, fetchPolicy:"network-only"}).then(e => {
        if (e && e.data && e.data.user.companies) {
          var FarmsData = e.data.user.companies
          if (FarmsData && FarmsData.length) {
            dispatch({type:''+gqlActions.user.setUserFarms, payload:FarmsData})
          }
        }
      })
    }
  },[UserToken, client, dispatch])

  const getUserData = async (jwt?:string) => {
    if (UserToken) {
      await client.query<UserInfoResponse>({query:USER_INFO, variables:{jwt:jwt?jwt:UserToken} as UserInfoArgs, fetchPolicy:"no-cache"}).then(e => {
        if (e && e.data && e.data.user.info) {
          //TODO: is not array.... ???
          var UserData = e.data.user.info
          if (UserData) { 
            dispatch({type:''+gqlActions.user.setUserData, payload:UserData})
          }
        }
      })
    }
  }
  const updateUserData = async (firstname:string,lastname:string,phone:string,email:string,address:string,country:string, jwt?:string) => {
    if (UserToken) {
      await client.mutate<UpdateUserInfoResponse>({mutation:UPDATE_USER_INFO, variables:{firstname, lastname, phone, email, address, country, jwt:jwt?jwt:UserToken} as UpdateUserInfoArgs}).then(e => {
        if (e && e.data && e.data.user.updateInfo) {
          //TODO: is not array.... ???
          var UserData = e.data.user.updateInfo
          if (UserData && UserData.success) {
            dispatch({type:''+gqlActions.user.setUserData, payload:{firstname, lastname, phone, email, address, country} as User_Data})
          }
        }
      })
    }
  }

  const getFarmData = async (domain:string) => {
    if (UserToken) {
      await client.query<FarmInfoResponse>({query:FARM_INFO, variables:{domain} as FarmInfoArgs}).then(e => {
        if (e && e.data && e.data.company.info) {
          //TODO: is not array.... ???
          var FarmData = e.data.company.info
          if (FarmData) { 
            dispatch({type:''+gqlActions.user.setFarmData, payload:FarmData})
          }
        }
      })
    }
  }
  const updateFarmData = async (name:string, city:string,street:string,phone:string,vat:string,email:string, domain?:string) => {
   
      await client.mutate<UpdateFarmInfoResponse>({mutation:UPDATE_FARM_INFO, variables:{city, street, phone, vat, email,domain} as UpdateFarmInfoArgs}).then(e => {
        if (e && e.data && e.data.company.updateInfo) {
          //TODO: is not array.... ???
          var FarmData = e.data.company.updateInfo
          if (FarmData && FarmData.success) {
            dispatch({type:''+gqlActions.user.setFarmData, payload:[{ name, city, street, phone, vat, email, domain }] as Farm_Data[]})
          }
        }
      }
    )
  }

  const getFarmSettings = async (domain: string) => {
    if (UserToken) {
      await client.query<CompanySettingsResponse>({query:GET_COMPANY_SETTINGS, variables:{domain}}).then(e => {
        if (e && e.data && e.data.company.settings) {
          dispatch({type:''+gqlActions.user.setFarmSettings, payload:e.data.company.settings})
        }
      })
    }
  }

  const updateFarmSettings = async (domain?:string, timeZone?: number, feedDayStart?: string) => {
    await client.mutate<UpdateCompanySettingsResponse>({mutation:UPDATE_COMPANY_SETTINGS, variables:{domain, timeZone, feedDayStart}}).then(e => {
      if (e && e.data && e.data.company.updateSettings) {
        dispatch({type:''+gqlActions.user.setFarmData, payload: e.data.company.updateSettings})
      }
    })
  }

  const doLogin = async (username:string, password:string):Promise<boolean> => {
    return await client.query<LoginResponse>({query:USER_LOGIN, variables:{username, password} as LoginArgs}).then(e => {
      if (e && e.data && e.data.authenticate) {
        const loginData = e.data.authenticate
        if (loginData.code + '' === "200" && loginData.message) {
          dispatch({type:''+gqlActions.user.setUserToken, payload:loginData.message})
          getUserFarms()
          return true
        }
      }
      return false
    })
  }
  const doLogOut = () => {
    if (UserToken) {
      dispatch({type:''+gqlActions.user.clear, payload:'all'}) //TODO: get actual type
    }
  }
  
  const createNewUser = async (username: string, password: string, firstname:string, lastname:string, email:string, phone:string) => {
    await client.query<CreateUserResponse>({query:CREATE_USER, variables:{username, password, firstname, lastname, email, phone} as CreateArgs}).then(e => {
      if (e && e.data && e.data.create) {
        const createData = e.data.create
        if (createData && createData.success) {
          dispatch({type:''+gqlActions.user.setUserData, payload: {username, password, firstname, lastname, email, phone} as CreateArgs})
        }
      }
    })
  }

  const createUserResetToken = async (username: string):Promise<boolean> => {
    return await client.mutate<CreateResetResponse>({mutation: CREATE_RESET_PASSWORD_ENTRY, variables: {username}}).then(e => {
      if (e && e.data && e.data.app.resetPassword) {
        return e.data.app.resetPassword.success;
      }
      return false
    })
  }

  const tokenResetPassword = async (token: string, password: string) => {
    return await client.mutate<TokenResetResponse>({mutation: TOKEN_RESET_PASSWORD, variables: {token, password}}).then(e => {
      if (e && e.data && e.data.app.createResetPasswordToken) {
        return e.data.app.createResetPasswordToken.success;
      }
      else return false
    })
  }

  const getServerIp = async () => {
    if (UserToken) {
      return await client.query<{serverIp: string}>({query: GET_SERVER_IP})
        .then((response) => {
          if (response && response.data.serverIp) {
            dispatch({type: String(gqlActions.user.setServerIp), payload: response.data.serverIp})
          }
        })
    }
  }
  
  return { doLogin, doLogOut, createNewUser, data:fullState, getUserFarms, userToken:UserToken, userFarms:UserFarms, getUserData, userData:UserData, updateUserData, getFarmData, farmData:FarmData, updateFarmData, farmSettings, getFarmSettings, updateFarmSettings, createUserResetToken, tokenResetPassword, serverIp, getServerIp}
}